import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EventsListLayer from "../../components/Events/EventsListLayer";

const EventsList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Curiouzz Social" />
        <EventsListLayer />
      </MasterLayout>
    </>
  );
};

export default EventsList;
